var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { staticClass: "row" },
    [
      _c(
        "div",
        {
          staticClass:
            "col-xl-5 col-lg-6 col-sm-12 col-xs-12 relative-position row items-center",
          attrs: { id: "login-left" }
        },
        [
          _c("q-card-main", { staticClass: "content-center col-12" }, [
            _c(
              "form",
              {
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                  }
                }
              },
              [
                _c("div", { staticClass: "logo text-center" }, [
                  _c("span", [_vm._v("cascades")])
                ]),
                _c(
                  "q-field",
                  { staticClass: "q-pa-md" },
                  [
                    _c("q-input", {
                      attrs: {
                        autofocus: "",
                        type: "email",
                        "float-label": "Email",
                        before: [{ icon: "email" }]
                      },
                      model: {
                        value: _vm.loginForm.email,
                        callback: function($$v) {
                          _vm.$set(_vm.loginForm, "email", $$v)
                        },
                        expression: "loginForm.email"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "q-field",
                  { staticClass: "q-pa-md full-width" },
                  [
                    _c("q-input", {
                      attrs: {
                        type: "password",
                        "float-label": "Password",
                        before: [{ icon: "lock" }]
                      },
                      model: {
                        value: _vm.loginForm.password,
                        callback: function($$v) {
                          _vm.$set(_vm.loginForm, "password", $$v)
                        },
                        expression: "loginForm.password"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "q-field",
                  { staticClass: "q-pa-md" },
                  [
                    _c("div", { staticClass: "float-right" }, [
                      _c(
                        "a",
                        {
                          staticClass: "dotted-underline pointer",
                          on: {
                            click: function($event) {
                              if (
                                $event.ctrlKey ||
                                $event.shiftKey ||
                                $event.altKey ||
                                $event.metaKey
                              ) {
                                return null
                              }
                              _vm.goToForgotPassword()
                            }
                          }
                        },
                        [_vm._v("Forgot password?")]
                      )
                    ]),
                    _c("q-checkbox", {
                      attrs: { label: "Keep me signed in" },
                      model: {
                        value: _vm.loginForm.persistLogin,
                        callback: function($$v) {
                          _vm.$set(_vm.loginForm, "persistLogin", $$v)
                        },
                        expression: "loginForm.persistLogin"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "text-right" },
                  [
                    _c(
                      "q-field",
                      { staticClass: "q-pa-md " },
                      [
                        _c("q-btn", {
                          attrs: {
                            size: "lg",
                            type: "submit",
                            loading: _vm.authenticating,
                            label: "Login",
                            color: "primary"
                          },
                          on: {
                            click: function($event) {
                              _vm.submitLoginFormMethod()
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "q-field",
                  { staticClass: "q-pa-md col-12 cta-box outline" },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "text-bold",
                        staticStyle: { "line-height": "25px" }
                      },
                      [_vm._v("ATTEND A CLASS")]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "float-right",
                        attrs: { id: "signInMethods" }
                      },
                      [
                        _c("q-btn", {
                          attrs: {
                            size: "sm",
                            label: "Attend",
                            icon: "people outline",
                            color: "secondary",
                            outline: ""
                          },
                          on: {
                            click: function($event) {
                              _vm.goToAttend()
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _c("div", {
        staticClass: "col-xl-7 col-lg-6  relative-position mobile-hide",
        attrs: { id: "login-picture" }
      }),
      _c("SignupModal", {
        attrs: { open: _vm.signupModal, toggle: _vm.toggleSignupModal }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }